import { useEffect, useState } from "react";
import { BookOpen, Compass, Layers, Rocket, Search, Wand2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

const STEPS = [
  [Compass, "Welcome to Production Studio", "This quick tour shows you where everything lives. You can replay it any time from 'Take the tour' in the left menu."],
  [BookOpen, "Start in My Books", "Create a book, comic, webtoon or poetry collection. Each project card shows a progress bar and its next step — click the step to go straight there."],
  [Layers, "Inside a project: 4 stages", "Tools are grouped as 1 Get started → 2 Improve → 3 Make editions → 4 Publish & share. A tip under the tabs explains what the open tool does."],
  [Wand2, "Edit vs Rewrite", "'Edit & Proofread' fixes mistakes and checks facts — your words stay yours. 'Rewrite & Expand' changes the writing itself with AI. Every change is saved as a new version you can undo."],
  [Search, "Lost? Press Ctrl K", "Search jumps to any book, tool or page. The 'Do this next' card at the top of each project always points to the next step."],
  [Rocket, "Ready to publish", "Build ebook, paperback, hardcover or audiobook files, run Preflight to catch KDP problems, then download everything from Exports."],
];

export function WelcomeTour() {
  const [open, setOpen] = useState(() => !localStorage.getItem("tour_done"));
  const [i, setI] = useState(0);
  useEffect(() => { const f = () => { setI(0); setOpen(true); }; window.addEventListener("open-tour", f); return () => window.removeEventListener("open-tour", f); }, []);
  const close = () => { localStorage.setItem("tour_done", "1"); setOpen(false); };
  const [Icon, title, text] = STEPS[i];
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md bg-slate-950 border-amber-500/30" data-testid="welcome-tour">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Icon size={18} className="text-amber-300" />{title}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-300 leading-relaxed" data-testid="tour-text">{text}</p>
        <div className="flex gap-1.5 justify-center">{STEPS.map((_, j) => <span key={j} className={`h-1.5 rounded-full transition-[width] ${j === i ? "w-6 bg-amber-500" : "w-1.5 bg-slate-700"}`} />)}</div>
        <div className="flex justify-between">
          <Button variant="ghost" onClick={close} className="text-slate-400" data-testid="tour-skip">Skip tour</Button>
          <div className="flex gap-2">
            {i > 0 && <Button variant="outline" className="border-slate-700" onClick={() => setI(i - 1)} data-testid="tour-back">Back</Button>}
            {i < STEPS.length - 1 ? <Button className="bg-amber-600 hover:bg-amber-500" onClick={() => setI(i + 1)} data-testid="tour-next">Next</Button>
              : <Button className="bg-amber-600 hover:bg-amber-500" onClick={close} data-testid="tour-finish">Get started</Button>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
